import _toConsumableArray from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { LevelState } from "../state";
import { FilterBasedAccessor } from "./FilterBasedAccessor";
import { TermQuery, TermsBucket, FilterBucket, BoolShould } from "../query/";

var map = require("lodash/map");

var each = require("lodash/each");

var compact = require("lodash/compact");

var take = require("lodash/take");

var omitBy = require("lodash/omitBy");

var isUndefined = require("lodash/isUndefined");

export var HierarchicalFacetAccessor =
/*#__PURE__*/
function (_FilterBasedAccessor) {
  _inherits(HierarchicalFacetAccessor, _FilterBasedAccessor);

  function HierarchicalFacetAccessor(key, options) {
    var _this;

    _classCallCheck(this, HierarchicalFacetAccessor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HierarchicalFacetAccessor).call(this, key));
    _this.state = new LevelState();
    _this.options = options;

    _this.computeUuids();

    return _this;
  }

  _createClass(HierarchicalFacetAccessor, [{
    key: "computeUuids",
    value: function computeUuids() {
      var _this2 = this;

      this.uuids = map(this.options.fields, function (field) {
        return _this2.uuid + field;
      });
    }
  }, {
    key: "onResetFilters",
    value: function onResetFilters() {
      this.resetState();
    }
  }, {
    key: "getBuckets",
    value: function getBuckets(level) {
      var field = this.options.fields[level];
      var buckets = this.getAggregations([this.options.id, field, field, "buckets"], []);
      return map(buckets, function (item) {
        item.key = String(item.key);
        return item;
      });
    }
  }, {
    key: "getOrder",
    value: function getOrder() {
      if (this.options.orderKey) {
        var orderDirection = this.options.orderDirection || "asc";
        return _defineProperty({}, this.options.orderKey, orderDirection);
      }
    }
  }, {
    key: "buildSharedQuery",
    value: function buildSharedQuery(query) {
      var _this3 = this;

      each(this.options.fields, function (field, i) {
        var filters = _this3.state.getLevel(i);

        var parentFilter = _this3.state.getLevel(i - 1);

        var isLeaf = !_this3.state.levelHasFilters(i + 1);
        var filterTerms = map(filters, TermQuery.bind(null, field));

        if (filterTerms.length > 0) {
          query = query.addFilter(_this3.uuids[i], filterTerms.length > 1 ? BoolShould(filterTerms) : filterTerms[0]);
        }

        if (isLeaf) {
          var selectedFilters = map(filters, function (filter) {
            return {
              id: _this3.options.id,
              name: _this3.translate(parentFilter[0]) || _this3.options.title || _this3.translate(field),
              value: _this3.translate(filter),
              remove: function remove() {
                _this3.state = _this3.state.remove(i, filter);
              }
            };
          });
          query = query.addSelectedFilters(selectedFilters);
        }
      });
      return query;
    }
  }, {
    key: "buildOwnQuery",
    value: function buildOwnQuery(query) {
      var _this4 = this;

      var lvlAggs = compact(map(this.options.fields, function (field, i) {
        if (_this4.state.levelHasFilters(i - 1) || i == 0) {
          return FilterBucket(field, query.getFiltersWithKeys(take(_this4.uuids, i)), TermsBucket(field, field, omitBy({
            size: _this4.options.size,
            order: _this4.getOrder()
          }, isUndefined)));
        }
      }));
      var aggs = FilterBucket.apply(void 0, [this.options.id, query.getFiltersWithoutKeys(this.uuids)].concat(_toConsumableArray(lvlAggs)));
      return query.setAggs(aggs);
    }
  }]);

  return HierarchicalFacetAccessor;
}(FilterBasedAccessor);